<script>
import { mapGetters } from 'vuex';
import LaravelEcho from '~/components/LaravelEcho.vue';
import Aside from './app/aside.vue';
import Footer from './app/footer.vue';
import NavBar from './app/nav-bar.vue';

export default {
  name: 'AppLayout',

  components: {
    NavBar,
    Aside,
    Footer,
    LaravelEcho,
  },

  computed: {
    ...mapGetters(['isLogged']),

    layout() {
      return `${this.$route.meta.layout || 'app'}-layout`;
    },
  },
};
</script>

<template>
  <div class="wrapper" v-if="isLogged">
    <NavBar />
    <Aside />
    <slide-y-up-transition mode="out-in" origin="center top">
      <router-view></router-view>
    </slide-y-up-transition>

    <LaravelEcho />
    <Footer />
  </div>
</template>
